module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitleab"
  }, [_c('a', {
    attrs: {
      "id": "page_xxix"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HERE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVERS AND")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNTAINS")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ING")])])]), _c('a', {
    attrs: {
      "id": "page_xxix"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/cmn.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f50aa36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/12_FM04.vue
// module id = 87
// module chunks = 0